import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { ServerNode, SqlServerModel } from '../ngx-query-editor.models';
import { Observable } from 'rxjs';
import { NgxQueryEditorAbstractService } from '../ngx-query-editor.abstract.service';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { MatMenuTrigger } from '@angular/material';

@Component({
  selector: 'lib-db-explorer',
  templateUrl: './db-explorer.component.html',
  styleUrls: ['./db-explorer.component.scss']
})
export class DbExplorerComponent implements OnInit {

  treeControl = new NestedTreeControl<ServerNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<ServerNode>();

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };

  @Output() newQueryTab = new EventEmitter<string>();
  @Output() stateEmitter = new EventEmitter<boolean>();

  @Input() serverSchema$: Observable<any[]>;
  @Input() serverModel$: Observable<SqlServerModel>;

  serverName: string;

  private serverTree = [];

  public emptyState: boolean;

  onContextMenu(event: MouseEvent, item: ServerNode) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'node': item };
    this.contextMenu.openMenu();
  }

  constructor(private queryEditorService: NgxQueryEditorAbstractService) {
  }

  public onOpenInEditor($event, nodeName: string) {
    this.newQueryTab.emit(nodeName);
  }

  hasChild = (_: number, node: ServerNode) => node.children && (
    node.type === 'server' || node.type === 'database' || node.type === 'table' || node.type === 'folder'
  )

  ngOnInit() {
    this.serverModel$.subscribe(server => {
      this.serverName = server.name;
      this.serverTree = [
        {
          name: this.serverName,
          type: 'server',
          children: []
        }
      ];
    });
    this.serverSchema$.subscribe(result => {
      result.forEach(elt => {
        const dbNode: ServerNode = {
          name: elt.database_name,
          type: 'database',
          children: [
            {
              name: 'tables',
              type: 'folder',
              children: []
            }
          ]
        };
        this.serverTree[0].children.push(dbNode);
      });
      this.emptyState = this.checkEmptyState();
      this.stateEmitter.emit(this.emptyState);
      if ( this.emptyState === false) {
        this.newQueryTab.emit(this.serverTree[0].children[1].name);
      }
      this.dataSource.data = this.serverTree;
    });
  }

  onClick(node: ServerNode) {
    if (!this.treeControl.isExpanded(node)) {
      if (node.name === 'tables' && node.type === 'folder') {
        const dbNode = this.serverTree[0].children.filter(child => child.children.includes(node))[0];
        const dbIndex = this.serverTree[0].children.indexOf(this.serverTree[0].children.filter(child => child === dbNode)[0]);
        const nodeIndex = this.serverTree[0].children[dbIndex].children.indexOf(node);
        this.serverTree[0].children[dbIndex].children[nodeIndex].children = [];
        this.queryEditorService.getCollectionSchema(node.name, dbNode.name).subscribe(
          result => {
            result.forEach(elt => {
              const dbNodetoAdd: ServerNode = {
                name: elt.tablE_SCHEMA + '.' + elt.tablE_NAME,
                type: 'table',
                children: [
                  {
                    name: 'columns',
                    type: 'folder',
                    children: []
                  }
                ]
              };
              this.serverTree[0].children[dbIndex].children[nodeIndex].children.push(dbNodetoAdd);
            });
            this.dataSource.data = null;
            this.dataSource.data = this.serverTree;
          });
      }

      if (node.type === 'table') {
        const dbName = this.serverTree[0].children.filter(child => child.children[0].children.includes(node))[0].name;
        const dbIndex = this.serverTree[0].children.indexOf(this.serverTree[0].children.filter(child => child.name === dbName)[0]);
        const nodeIndex = this.serverTree[0].children[dbIndex].children[0].children.indexOf(node);
        const tableName = this.serverTree[0].children[dbIndex].children[0].children[nodeIndex].name;
        this.serverTree[0].children[dbIndex].children[0].children[nodeIndex].children = [];
        this.queryEditorService.getCollectionSchema('columns', dbName).subscribe(
          result => {
            result.forEach(elt => {
              if (elt.tablE_SCHEMA + '.' + elt.tablE_NAME === tableName) {
                const dbNodetoAdd: ServerNode = {
                  name: elt.columN_NAME,
                  type: 'column',
                };
                this.serverTree[0].children[dbIndex].children[0].children[nodeIndex].children.push(dbNodetoAdd);
              }
            });
            this.dataSource.data = null;
            this.dataSource.data = this.serverTree;
          });
      }
    }
  }

  onRefreshClick() {
    this.serverTree = [
      {
        name: this.serverName,
        type: 'server',
        children: []
      }
    ];

    this.serverSchema$.subscribe(result => {
      result.forEach(elt => {
        const dbNode: ServerNode = {
          name: elt.database_name,
          type: 'database',
          children: [
            {
              name: 'tables',
              type: 'folder',
              children: []
            }
          ]
        };
        this.serverTree[0].children.push(dbNode);
      });
      this.emptyState = this.checkEmptyState();
      this.stateEmitter.emit(this.emptyState);
      this.dataSource.data = this.serverTree;
    });
  }

  checkEmptyState(): boolean {
    return (this.serverTree[0].children.length === 0 ||
      (this.serverTree[0].children[0].name === 'master' && this.serverTree[0].children.length === 1 ) );
  }

  ResolveIcon(node: ServerNode): string {

    if (node.type === 'folder') {
      return 'folder';
    } else if (node.type === 'view') {
      return 'pageview';
    } else if (node.type === 'table') {
      return 'table_chart';
    } else if (node.type === 'column') {
      return 'view_column';
    } else if (node.type === 'index') {
      return 'view_headline';
    } else if (node.type === 'trigger') {
      return 'dehaze';
    } else if (node.type === 'server') {
      return 'dvr';
    } else if (node.type === 'database') {
      return 'apps';
    } else {
      return 'insert_drive_file';
    }
  }
}
